import {
    OrganizationManagementApi,
    PowertrainApi,
    HeaderApi,
} from 'api';
import { apiCallStatus, commonRequestParams } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes, pageSizeOrg } from './constants';
import { getExistingSiteIds } from 'helpers/sitesHelper';
import { getApiActionCreator } from 'helpers/actionHelper';
import {
    formatSiteAssetGroupRequest,
    formatAssetsRequest
} from './helpers';


// Action creators
const getOrganizationsAction = getApiActionCreator(actionTypes.GET_ORGANIZATIONS);
const getAssetsAction = getApiActionCreator(actionTypes.GET_ASSETS);
const getPowertrainsAction = getApiActionCreator(actionTypes.GET_POWERTRAINS);
export const getSitesAction = getApiActionCreator(actionTypes.GET_SITES);
export const getAssetGroupsAction = getApiActionCreator(actionTypes.GET_ASSET_GROUPS);
export const reloadContextAction = getApiActionCreator(actionTypes.SET_RELOAD_CONTEXT_LOADING_STATUS);
export const getLastSelectedOrganizationAction = getApiActionCreator(actionTypes.GET_LAST_SELECTED_ORGANIZATION);

export const getAvailableAssets = (organizations, refreshData, countries) => {
    return (dispatch) => {
        dispatch(getAssetsAction(apiCallStatus.LOADING));
        HeaderApi.getAvailableAssets({ ...formatAssetsRequest(organizations, countries), refreshData })
            .then((availableAssets) => {
                dispatch({
                    type: 'AVAILABLE_ASSETS'
                });
                dispatch(getAssetsAction(apiCallStatus.SUCCESS, availableAssets));
            }, (err) => {
                dispatch({
                    type: 'AVAILABLE_ASSETS'
                });
                logger.error(err);
            });
    };
};

export const setSelectedFilters = (selectedFilters) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_SELECTED_FILTERS,
            selectedFilters
        });
    };
};

export const setCIAMSyncFlag = (refeshCIAMSync) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_CIAM_SYNC_FLAG,
            refeshCIAMSync
        });
    };
};

export const setCIAMSyncAndRefreshFlags = (refeshAndCIAMSync) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_CIAM_SYNC_AND_REFRESH_FLAG,
            refeshAndCIAMSync
        });
    };
};

export const setPowertrainSyncFlag = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_POWERTRAIN_SYNC_FLAG
        });
    };
};

export const setAssetGroupSyncFlag = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_ASSET_GROUP_SYNC_FLAG
        });
    };
};

export const setAssetSyncFlag = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_ASSETS_SYNC_FLAG
        });
    };
};

export const saveFilters = () => {
    return (dispatch, getState) => {
        const { sites, assetGroups, selectedFilters } = getState().generalFilterEdit;
        dispatch({
            ...sites,
            type: actionTypes.GET_SITES
        });
        dispatch({
            ...assetGroups,
            type: actionTypes.GET_ASSET_GROUPS
        });
        dispatch({
            type: actionTypes.SET_SELECTED_FILTERS,
            selectedFilters
        });
    };
};
export const loadAssets = (organizations, isRefresh, dispatch) => {
    dispatch(getAssetsAction(apiCallStatus.LOADING));
    return HeaderApi.getAssets(organizations, isRefresh).then(assets => {
        dispatch(getAssetsAction(apiCallStatus.SUCCESS, assets));
    }, (err) => {
        dispatch(getAssetsAction(apiCallStatus.ERROR, [], err));
    });

};
export const loadPowertrainsV2 = (sites, organizations, isRefresh, dispatch, countries) => {
    let powerTrainParams = {
        siteIds: getExistingSiteIds(sites),
        refreshData: isRefresh
    };
    powerTrainParams = { ...powerTrainParams, ...formatSiteAssetGroupRequest(organizations, countries) };

    dispatch(getPowertrainsAction(apiCallStatus.LOADING));
    return PowertrainApi.getPowertrains(powerTrainParams)
        .then((powertrains) => {
            dispatch(getPowertrainsAction(apiCallStatus.SUCCESS, powertrains));
        }, (err) => {
            dispatch(getPowertrainsAction(apiCallStatus.ERROR, [], err));
        });
};

export const getUserOrganizations = () => {
    const params = {
        ...commonRequestParams,
        pageSize: pageSizeOrg,
        onlyFavorites: false,
        nameFilter: ''
    };

    return (dispatch) => {
        dispatch(getOrganizationsAction(apiCallStatus.LOADING));
        OrganizationManagementApi.getUserOrganizations(params)
            .then((organizations) => {
                dispatch(getOrganizationsAction(apiCallStatus.SUCCESS, organizations));
                logger.debug('Organizations successfully loaded');
            }, (err) => {
                dispatch(getOrganizationsAction(apiCallStatus.ERROR, [], err));
            });
    };
};

const getSites = (organizations, dispatch) => {
    dispatch(getSitesAction(apiCallStatus.LOADING));
    return HeaderApi.getSites(formatSiteAssetGroupRequest(organizations))
        .then((sites = []) => {
            dispatch(getSitesAction(apiCallStatus.SUCCESS, sites));
        }, (err) => {
            dispatch(getSitesAction(apiCallStatus.ERROR, null, err));
        });
};

const getAssetGroups = (organizations, dispatch, countries) => {
    dispatch(getAssetGroupsAction(apiCallStatus.LOADING));
    return HeaderApi.getAssetGroups(formatSiteAssetGroupRequest(organizations, countries))
        .then((assetGroups = []) => {
            dispatch(getAssetGroupsAction(apiCallStatus.SUCCESS, assetGroups));
        }, (err) => {
            dispatch(getAssetGroupsAction(apiCallStatus.ERROR, [], err));
        });
};

export const setSites = (sites) => {
    return (dispatch) => {
        dispatch(getSitesAction(apiCallStatus.SUCCESS, sites));
    };
};

export const setAssetGroups = (assetGroups) => {
    return (dispatch) => {
        dispatch(getAssetGroupsAction(apiCallStatus.SUCCESS, assetGroups));
    };
};

export const getSitesAndAssetGroups = (organizations) => {
    return (dispatch, getState) => {
        const countries = getState().generalFilter?.selectedFilters?.countries;
        Promise.all([
            getSites(organizations, dispatch),
            getAssetGroups(organizations, dispatch, countries)
        ]);
    };
};

export const loadAssetsAndPowertrainsAndContracts = (organizations, isRefresh) => {
    return (dispatch, getState) => {
        const sites = getState().generalFilter.sites.data;
        const countries = getState().generalFilter?.selectedFilters?.countries;
        Promise.all([
            loadPowertrainsV2(sites, organizations, isRefresh, dispatch, countries),
        ]);
    };
};

//export const loadPowertrains
export const searchAssetRequest = (searchValue, assets, callback, clearQueryParameter, defaultOrganizations, history) => ({ // PASSING HISTORY FOR NAVIGATION FROM LEGACY ID TO MICRO-SERVICE ID ON ASSET SEARCH FROM GENERAL FILTER
    type: actionTypes.ASSET_SEARCH_REQUEST,
    searchValue,
    assets,
    callback,
    clearQueryParameter,
    defaultOrganizations,
    history
});

export const launchCIAMSyncForAdmin = (organizations, countries, refreshData) => {
    return (dispatch) => {
        dispatch(setCIAMSyncFlag(true));
        dispatch(getAssetsAction(apiCallStatus.LOADING));
        dispatch(getPowertrainsAction(apiCallStatus.LOADING));
        return HeaderApi.getAvailableAssets({ ...formatAssetsRequest(organizations, countries), refreshData })
            .then((availableAssets) => {
                dispatch({
                    type: 'AVAILABLE_ASSETS'
                });
                dispatch(getAssetsAction(apiCallStatus.SUCCESS, availableAssets));
                dispatch(loadAssetsAndPowertrainsAndContracts(organizations, refreshData));
                dispatch(setCIAMSyncFlag(false));
                logger.debug('Asset list loaded from microservice');
            }, (err) => {
                dispatch({
                    type: 'AVAILABLE_ASSETS'
                });
                dispatch(setCIAMSyncFlag(false));
                logger.error(err);
            });
    };
};

export const searchOrgRequest = (orgId, organizations, isAdmin, isCIAMSyncFlag) => ({
    type: actionTypes.ORG_SEARCH_REQUEST,
    orgId,
    organizations,
    isAdmin,
    isCIAMSyncFlag
});

export const saveFiltersWithSync = () => {
    return (dispatch, getState) => {
        const { sites, assetGroups, selectedFilters } = getState().generalFilterEdit;
        dispatch({
            ...sites,
            type: actionTypes.GET_SITES
        });
        dispatch({
            ...assetGroups,
            type: actionTypes.GET_ASSET_GROUPS
        });
        dispatch({
            type: actionTypes.SET_SELECTED_FILTERS,
            selectedFilters
        });
        return dispatch(launchCIAMSyncForAdmin(selectedFilters?.organizations, selectedFilters?.countries, true));
    };
};

export const updateRefreshDataFlag = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.UPDATE_REFRESH_DATA_FLAG
        });
    };
};

export const updateLastSelectedOrganization = (organization) => {
    return () => {
        OrganizationManagementApi.updateLastSelectedOrganization(organization?.organizationID)
            .then(() => {
                logger.debug('Last selected organization updated');
            })
            .catch((err) => {
                logger.error('Failed to update last selected organization:', err);
            });
    };
};

export const getLastSelectedOrganization = () => {
    return (dispatch) => {
        dispatch(getLastSelectedOrganizationAction(apiCallStatus.LOADING));
        OrganizationManagementApi.getLastSelectedOrganization()
            .then((organization) => {
                dispatch(getLastSelectedOrganizationAction(apiCallStatus.SUCCESS, organization));
            })
            .catch((err) => {
                dispatch(getLastSelectedOrganizationAction(apiCallStatus.ERROR, err));
            });
    };
};
